import { initEmbeds, getCookie, setCookie } from './utils/fn';
import $ from 'jquery';
// import $ from 'jquery';
//import ShareBoxInline from '../../../components/shares-box/share-box-inline';

export const oneTrust =  {
    params: null,
    usedMethods: {
      'initEmbeds': new Map(),
      'initShareBlock': new Map(),
    },
    shareBlocks: [],
    buttonSelector: '#ot-sdk-btn.ot-sdk-show-settings',
    oneTrustCookieName: 'OptanonConsent',
    currentEdition: $('body').data('edtn'),
    excludeEditions: ['br', 'ev_br'],
    currentEnvironment: gtmDataLayer[0].currentEnv,
    isDevelopment: false,
    // sdas

    FUNCTIONAL_COOKIE: 'C0005:1',

    _init: false,

    getParams() {
      const _this = window.msOneTrust;

      if (_this.params) {
        return _this.params;
      }

      _this.params = {};

      if (window.msAppOneTrustParams) {
        const params = window.msAppOneTrustParams;
        typeof params === 'string' ? _this.params = JSON.parse(params) : _this.params = params;
      } else {
        const cookie = getCookie(_this.oneTrustCookieName);

        // console.log(_this.oneTrustCookieName);
        // console.log('cookie ' + cookie);

        if (!cookie && !_this.isExcludedEdition()) {

          setTimeout(() => {
            _this.cookieChanged();
          }, 1000);
          return _this.params;
        }

        const params = new URLSearchParams(cookie);

        for(var [key, value] of params.entries()) {
          _this.params[key] = params.get(key);
        }

        if (!_this.params['groups'] && !_this.isExcludedEdition()) {
          setTimeout(() => {
            _this.cookieChanged();
          }, 1000);
          return _this.params;
        }
      }

      return _this.params;
    },

    init() {
      const _this = window.msOneTrust;
      // console.log('enter init');

      if (_this._init) {
        return;
      }

      _this._init = true;
      
      _this.oneTrustButton = $(window.msOneTrust.buttonSelector);

      if (_this.oneTrustButton.length) {
        $('body').on('click', '.ms-onetrust_stub-button', () => {
          _this.oneTrustButton.trigger('click');
        })
      }


      window.OneTrust && 
      window.OneTrust.OnConsentChanged && 
      typeof window.OneTrust.OnConsentChanged === 'function' && 
      window.OneTrust.OnConsentChanged(() => {
        window.msOneTrust.cookieChanged();
      });

      if (_this.isDevelopment) {
        _this._setCookie(1);
      }

      _this.cookieChanged();
    },

    isAlowed(code) {
      const _this = window.msOneTrust;
      const params = _this.getParams(); 
      return _this.isExcludedEdition() || (params && params['groups'] && params['groups'].search(code) != -1);
    },

    isExcludedEdition() {
      const _this = window.msOneTrust;
      return _this.excludeEditions.includes(_this.currentEdition);
    },

    initEmbeds($page) {
      const _this = window.msOneTrust;
      // console.log('embeds init');

      if (!_this.usedMethods['initEmbeds'].has($page)) {
        _this.usedMethods['initEmbeds'].set($page, $page);
      }

      if (oneTrust.currentEnvironment == 'development' || oneTrust.currentEnvironment == 'stage' || oneTrust.currentEnvironment == 'test') {
        if (_this._init) {
          return;
        }
      } else {
        if (!_this._init) {
          return;
        }
      }

      if (oneTrust.currentEnvironment === 'development' || oneTrust.currentEnvironment == 'test') {
        initEmbeds($page);
        return;
      }

      if (!_this.isAlowed(_this.FUNCTIONAL_COOKIE)) {
        $page.find('.embed-item').each((index, element) => {
          $(element).empty().append(_this.getStub());
        });

        $page.find('.ms-share_twitter').hide();
        return;
      }
      
      $page.find('.ms-share_twitter').show();
      initEmbeds($page);
      setInterval(function() { 
        if (typeof instgrm === 'object') {
          instgrm.Embeds.process();
        }
      }, 2500);    
    },

    initShareBlock($page) {
      const _this = window.msOneTrust;

      if (!_this.usedMethods['initShareBlock'].has($page)) {
        _this.usedMethods['initShareBlock'].set($page, $page);
      }

      if (oneTrust.currentEnvironment == 'development' || oneTrust.currentEnvironment == 'stage' || oneTrust.currentEnvironment == 'test') {
        if (_this._init) {
          return;
        }
      } else {
        if (!_this._init) {
          return;
        }
      }

      if (oneTrust.currentEnvironment === 'development' || oneTrust.currentEnvironment == 'test')  {
        $page.find('.shareBox').show();
        return;
      }

      if (!_this.isAlowed(_this.FUNCTIONAL_COOKIE)) {
        $page.find('.shareBox').hide();
        return;
      }

      $page.find('.shareBox').show();
    },

    cookieChanged() {
      const _this = window.msOneTrust;
      _this.params = null;

      for (const methodName in _this.usedMethods) {
        if(_this.usedMethods.hasOwnProperty(methodName) && _this.hasOwnProperty(methodName)) {
          for(let params of _this.usedMethods[methodName].values()) {
            _this[methodName](params);
          }
        }
      }

      return true;
    },

    getStub() {
      return `<div class="ms-onetrust_stub">
                <h3 class="ms-onetrust_stub-title">${i18n.cookie_settings}</h3>
                <p class="ms-onetrust_stub-text">${i18n.content_blocked}</p>
                <p class="ms-onetrust_stub-text">${i18n.click_to_show_content}</p>
                <div class="ms-onetrust_stub-button">${i18n.open_settings}</div>
              </div>`;
    },

    _setCookie(val) {
      // console.log('set cookie');
      const _this = window.msOneTrust;
      if (oneTrust.isDevelopment) {
        // console.log('_this.oneTrustCookieName' + ' ' +_this.oneTrustCookieName);
        const url = new URLSearchParams();
        url.append('groups', val ? _this.FUNCTIONAL_COOKIE : 'C0005:0');
        // $.cookie(_this.oneTrustCookieName, url.toString());
        setCookie(_this.oneTrustCookieName, url.toString, 0);
      }
    },
 
    _switch (val) {
      const _this = window.msOneTrust;
      if (oneTrust.isDevelopment) {
        // _this.params = {};
        _this._setCookie(val);
        _this.cookieChanged();
      }
    }
}

window.msOneTrust = oneTrust;

((oneTrust.isDevelopment) || window.msOneTrust.isExcludedEdition()) &&  window.msOneTrust.init();


$(window).on('oneTrustReady', oneTrust.init)